export const FETCHING_ABORTED = 'Fetching aborted';
export const DRF_NON_FIELD_ERRORS = 'non_field_errors' as const;
